import { DynamicContentType, FileEntryBM } from '@bm-js/atlascloud-shared'
import { GalleryData } from '@bm-js/atlascloud-shared'
import { useMemo } from 'react'
import { ResponsiveImage, Spotlight } from './ResponsiveImage'
import { useImageOptions, useMargin } from '../utils/hooks'

const NUMBER_OF_COLUMNS = 3

type Props = {
  content: DynamicContentType<GalleryData>
  spotlight?: Spotlight
}

export const Gallery = ({ content, spotlight }: Props) => {
  const columns = useMemo(() => {
    const columns: (FileEntryBM | undefined)[][] = []
    for (let i = 0; i < NUMBER_OF_COLUMNS; i++) {
      columns.push([])
    }
    content.data.images.forEach((image, i) => {
      columns[i % NUMBER_OF_COLUMNS].push(image)
    })
    return columns
  }, [content.data.images])

  const margins = useMargin(content)
  const imageOptions = useImageOptions(content)

  return (
    <div className='@container'>
      <div
        className={`grid items-start gap-12 @2xl:grid-cols-3 @2xl:gap-16 ${margins}`}
      >
        {columns.map((column, i) => (
          <button
            key={`gallery_${content.uuid}_col_${i}`}
            className={`grid gap-12 @2xl:gap-12 ${i === 1 ? '' : ' mt-16'}`}
          >
            {column.map((image, j) => (
              <ResponsiveImage
                onClick={() => spotlight?.(image)}
                className={`${imageOptions} w-full`}
                key={`gallery_${content.uuid}_col_${i}_img_${j}`}
                file={image}
              />
            ))}
          </button>
        ))}
      </div>
    </div>
  )
}
